import React from "react";
import { Disccount, InvoiceComp, InvoiceSubejct, Paycard } from "./InvoiceComp";

const Invoice = () => {
  return (
    <div className="flex gap-4 flex-col md:flex-row ">
      <div className="lg:flex-[3]">
        <InvoiceComp></InvoiceComp>
        <div className=" bg-white overflow-scroll h-[500px] rounded-md shadow-[0px_4px_24px_0px_rgba(34,41,47,10%)] ">
          <InvoiceSubejct></InvoiceSubejct>
          <Disccount></Disccount>
        </div>
      </div>
      <div className="flex-1">
        <Paycard></Paycard>
      </div>
    </div>
  );
};

export default Invoice;
